import { api } from 'src/api/axios';

export const useCheckAcrylic = (idAcrylic: any) => api.get(`/api/cms/acrylic-plate/check-deletion/${idAcrylic}`);
